<template>
  <div class="sideBar-index">
    <el-menu
      :default-active="activeRouter"
      router="true"
      class="el-menu-vertical-demo"
      text-color="#666666"
      active-text-color="#191C29"
    >
      <el-menu-item index="/mineSubject">我的课程</el-menu-item>
      <el-menu-item index="/shoppingCart">购物车</el-menu-item>
      <el-menu-item index="/mineOrder">我的订单</el-menu-item>
      <!-- <el-menu-item index="/mineAddress">收货地址</el-menu-item> -->
    </el-menu>
  </div>
</template>

<script lang="ts">
import router from "@/router";
import { defineComponent,onBeforeMount,ref, watchEffect } from "vue";
import { useRouter, useRoute } from "vue-router";

export default defineComponent({
  name: "sideBar",
  setup(){
    const activeRouter = ref();
    const route = useRoute()
    watchEffect(()=>{
      activeRouter.value = route.path;
    })
    return{
      activeRouter
    }
  }
  

});
</script>
<style lang="less">
.sideBar-index {
  .el-menu {
    border: none;
    .el-menu-item {
      padding: 0 !important;
      text-align: center;
      display: block;
      line-height: 70px;
      height: 70px;
      position: relative;
      font-size: 18px;
      &:hover {
        background: rgba(255, 202, 40, 0.3);
      }
    }
    .el-menu-item.is-active {
      font-weight: 600;
      &::before {
        position: absolute;
        left: 0;
        top: 50%;
        transform: translateY(-50%);
        content: "";
        display: block;
        width: 6px;
        height: 25px;
        background: #ffca28;
        border-radius: 3px;
      }
    }
  }
}
</style>
<style lang="less" scoped>
@import "@/assets/styles/common.less";
.sideBar-index {
  padding: 20px 0;
}
</style>